"use client"

import { QueryClientProvider } from "@tanstack/react-query"
import { useEffect, useState } from "react"
import { makeQueryClient } from "@/lib/query-client"
import { bootstrapApiClient } from "@/lib/api/client"
import { Toaster } from "sonner"

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => makeQueryClient())
  useEffect(() => {
    bootstrapApiClient()
  }, [])
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast: "font-sans text-sm",
          },
        }}
        richColors
        closeButton
      />
    </QueryClientProvider>
  )
}
